<template>
  <div class="c-article-card">
    <div class="c-article-card__figure">
      <img :src="entry.image" :alt="entry.title">
    </div>
    <div class="c-article-card__body">
      <div class="c-article-card__meta u-st2">
        <div>{{ entry.postDate.date }}</div>
        <div v-if="entry.source">{{ entry.source }}</div>
      </div>
      <a :href="link" v-if="link" target="_blank">
        <h4 class="c-article-card__heading u-st1">{{ entry.title }}</h4>
      </a>
      <router-link :to="{ name: 'article', params: { slug: entry.slug }}" v-else>
        <h4 class="c-article-card__heading u-st1">{{ entry.title }}</h4>
      </router-link>
      <div class="c-article-card__read-more">
        <a class="u-st2" :class="themeGrey ? 'c-read-more c-read-more--grey' : 'c-read-more'" :href="link" target="_blank" v-if="link">
          <img class="c-read-more__img" src="@/assets/arrow-right-grey.svg" width="32" alt="Right arrow" v-if="themeGrey">
          <img class="c-read-more__img" src="@/assets/arrow-right-blue.svg" width="32" alt="Right arrow" v-else>
          {{ linkText }}
        </a>
        <router-link class="u-st2" :class="themeGrey ? 'c-read-more c-read-more--grey' : 'c-read-more'" :to="{ name: 'article', params: { slug: entry.slug }}" v-else>
          <img class="c-read-more__img" src="@/assets/arrow-right-grey.svg" width="32" alt="Right arrow" v-if="themeGrey">
          <img class="c-read-more__img" src="@/assets/arrow-right-blue.svg" width="32" alt="Right arrow" v-else>
          {{ linkText }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ArticleCard',
  props: {
    entry: {
      type: Object,
      required: true
    },
    linkText: {
      type: String,
      default: 'Read more'
    },
    link: {
      type: String
    },
    themeGrey: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    entry: function (newEntry, oldEntry) {
      this.entry.postDate.date = moment(this.entry.postDate.date).format('D MMMM YYYY')
    }
  },
  mounted () {
    this.entry.postDate.date = moment(this.entry.postDate.date).format('D MMMM YYYY')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ArticleCard.vue